import type { i18n as I18n, PostProcessorModule } from "i18next";
import { isMachineTranslatedKey } from "./machine-translation-overlay";
import { isMachineTranslationPreviewActive } from "./machine-translation-preview";
import {
  getPostProcessorResolvedKey,
  getPostProcessorResolvedLocale,
} from "./post-processor-options";

export const MACHINE_TRANSLATION_INDICATOR_PREFIX = "[MT] ";

export function createMachineTranslationIndicatorPostProcessor(
  instance: I18n
): PostProcessorModule {
  return {
    type: "postProcessor",
    name: "machine-translation-indicator",
    process(value, key, options) {
      if (!isMachineTranslationPreviewActive()) {
        return value;
      }

      const lng = getPostProcessorResolvedLocale(options) ?? instance.language;
      const resolvedKey = getPostProcessorResolvedKey(options, key);
      const fromMachine =
        resolvedKey !== undefined && isMachineTranslatedKey(lng, resolvedKey);

      if (!fromMachine) {
        return value;
      }

      return `${MACHINE_TRANSLATION_INDICATOR_PREFIX}${value}`;
    },
  };
}
